import React, { useContext } from 'react';
import styled from 'styled-components';
import colors from '../data/colors';
import { StateContext } from '../data/stateContext';
import patchUser from '../functions/patchUser';
import { putAnswers } from '../functions/strapiGet';

const SubmitButton = styled.button`
    padding: ${props => props.active ? "1rem": "0rem"};
    background-color:${colors[5]};
    border:none;
    border-radius: 5px;
    margin:0 auto;
    overflow: hidden ;
    height:${props => props.active ? "3em" : "0"};
    color:white;
    display: block ;
    /* display:${props => props.active ? "block" : "none"} ; */
    transition: padding 0.4s ease-in-out, height 0.4s ease-in-out;
    cursor:pointer;
    &:active {
        transform:scale(0.9) ;
    }
    &:hover {
        background-color:${colors[2]} ;
    }
`

function Submit(props) {

    const {user, jwt, setUser} = useContext(StateContext)
    const {answers, setProgress, progress} = props

    const handleSubmit = () => {
        // console.log(answers, user.id, user.motivator_answers);
        // const cb = (resp) => {
        //     console.log(resp)
            

        // }
        const prevAnswers = user.motivator_answers ? [...user.motivator_answers] : []
        putAnswers(user.id,prevAnswers, answers,setProgress, jwt)
        .then(res => {
            setUser(res)
            setProgress(7)
        })
    }

    return ( 
        <SubmitButton active={progress === 6} onClick={()=> handleSubmit()}>
            {props.lang === "en" ? "SUBMIT RESULT" : "SEND RESULTAT"}
        </SubmitButton> 
    );
}

export default Submit;